import {
  IElementsState,
  selectChildDepthFirst,
  selectChildrenDepthFirst,
  selectRootIElement,
} from "@faro-lotv/app-component-toolbox";
import { assert } from "@faro-lotv/foundation";
import {
  IElementModel3dStream,
  isIElementBimModelTimeSeries,
  isIElementModel3dStream,
} from "@faro-lotv/ielement-types";
import { createSelector } from "@reduxjs/toolkit";
import { selectIElementsSlice } from "../ielements-slice-selector";

/**
 * Selects all CAD models in the project. This selector is memoized,
 * therefore it is run only when the iElements slice of the store changes.
 *
 * @param state Current state
 * @returns array of all IElementModel3dStream in the project
 */
export const selectAllCadModels = createSelector(
  [selectIElementsSlice],
  computeAllCadModels,
);

function computeAllCadModels(
  iElements: IElementsState,
): IElementModel3dStream[] {
  const iElementsState = { iElements };
  const root = selectRootIElement(iElementsState);
  assert(root, "Invalid project without a root");

  const bimTimeSeries = selectChildrenDepthFirst(
    root,
    isIElementBimModelTimeSeries,
    4,
  )(iElementsState);

  return bimTimeSeries.flatMap(
    (ts) =>
      selectChildDepthFirst(ts, isIElementModel3dStream)(iElementsState) ?? [],
  );
}
